import React, { useState } from 'react';

function SeeHowBtn() {
  const [hovered, setHovered] = useState(false);
  return (
    <a
      href="https://concierge.momorox.com"
      style={{ display: 'inline-block', font: '500 14px Archivo,sans-serif', color: '#111', background: hovered ? '#c5e19b' : '#dcedc2', textDecoration: 'none', padding: '13px 22px', borderRadius: '2px', transition: 'background .18s ease' }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      See how it works
    </a>
  );
}

export default function Mission() {
  return (
    <div className="mx-cta-grid">
      <div>
        <img src="/assets/momorox-symbol.png" alt="" style={{ width: '34px', height: '34px', display: 'block', marginBottom: '22px' }} />
        <h2 className="mx-cta-head">
          Stop chasing reps, labs and after-hours calls.
        </h2>
      </div>
      <div>
        <p style={{ margin: '0 0 22px', font: '400 15px/1.6 Archivo,sans-serif', color: 'rgba(243,249,233,.7)' }}>
          Samples from the brands you prescribe, labs that publish turnaround, software that fits what you run, and a widget that books patients at 11pm.
        </p>
        <SeeHowBtn />
      </div>
    </div>
  );
}
